import {
  FETCH_BALANCE_LOADING,
  FETCH_BALANCE_SUCCESS,
  FETCH_BALANCE_ERROR
} from '../Types/wfhBalanceTypes';

const initState = {
  data: [],
  error: null,
  success: null,
  loading: true,
  item: {}
};

const wfhBalanceReducer = (state = initState, action) => {
  switch (action.type) {
    case FETCH_BALANCE_LOADING:
      return {
        ...state,
        loading: true
      };

    case FETCH_BALANCE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: null,
        data: action.payload.data || action.payload,
        pagination: action.payload.pagination || null
      };

    case FETCH_BALANCE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: null
      };

    default:
      return state;
  }
};

export default wfhBalanceReducer;
